import React from 'react';
import { Facebook, Instagram, Mail, MapPin, Phone } from 'lucide-react';
export function Footer() {
  return <footer className="bg-stone-900 text-stone-400 py-16" data-id="element-9">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-11">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1" data-id="element-12">
            <div className="flex items-center gap-2 mb-6" data-id="element-13">
              <div className="h-8 w-8 rounded-full flex items-center justify-center" style={{
              backgroundColor: '#074e3b'
            }} data-id="element-14">
                <span className="text-white font-serif font-bold" data-id="element-15">W</span>
              </div>
              <span className="text-xl font-serif font-bold text-stone-100" data-id="element-16">
                Well Balanced Nutrition
              </span>
            </div>
            <p className="text-sm leading-relaxed mb-6" data-id="element-17">
              Compassionate, evidence-based nutrition coaching for real life.
            </p>
            <div className="flex gap-4" data-id="element-18">
              <a href="#" className="hover:text-white transition-colors" data-id="element-19">
                <Facebook className="h-5 w-5" data-id="element-20" />
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-21">
                <Instagram className="h-5 w-5" data-id="element-22" />
              </a>
            </div>
          </div>

          {/* Locations */}
          <div className="col-span-1 md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-23">
            <div data-id="element-24">
              <h4 className="text-white font-bold mb-4" data-id="element-25">Clemmons Office</h4>
              <ul className="space-y-3 text-sm" data-id="element-26">
                <li className="flex gap-3" data-id="element-27">
                  <MapPin className="h-5 w-5 shrink-0" data-id="element-28" />
                  <span data-id="element-29">
                    123 Wellness Way, Suite 100
                    <br data-id="element-30" />
                    Clemmons, NC 27012
                  </span>
                </li>
                <li className="flex gap-3" data-id="element-31">
                  <Phone className="h-5 w-5 shrink-0" data-id="element-32" />
                  <span data-id="element-33">(336) 555-0123</span>
                </li>
              </ul>
            </div>
            <div data-id="element-34">
              <h4 className="text-white font-bold mb-4" data-id="element-35">Durham Office</h4>
              <ul className="space-y-3 text-sm" data-id="element-36">
                <li className="flex gap-3" data-id="element-37">
                  <MapPin className="h-5 w-5 shrink-0" data-id="element-38" />
                  <span data-id="element-39">
                    456 Bull City Blvd, Suite 200
                    <br data-id="element-40" />
                    Durham, NC 27701
                  </span>
                </li>
                <li className="flex gap-3" data-id="element-41">
                  <Phone className="h-5 w-5 shrink-0" data-id="element-42" />
                  <span data-id="element-43">(919) 555-0123</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Links */}
          <div data-id="element-44">
            <h4 className="text-white font-bold mb-4" data-id="element-45">Quick Links</h4>
            <ul className="space-y-2 text-sm" data-id="element-46">
              <li data-id="element-47">
                <a href="#" className="hover:text-white transition-colors" data-id="element-48">
                  Client Portal
                </a>
              </li>
              <li data-id="element-49">
                <a href="#" className="hover:text-white transition-colors" data-id="element-50">
                  For Providers
                </a>
              </li>
              <li data-id="element-51">
                <a href="#" className="hover:text-white transition-colors" data-id="element-52">
                  Blog & Resources
                </a>
              </li>
              <li data-id="element-53">
                <a href="#" className="hover:text-white transition-colors" data-id="element-54">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-stone-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm" data-id="element-55">
          <p data-id="element-56">
            &copy; {new Date().getFullYear()} Well Balanced Nutrition. All
            rights reserved.
          </p>
          <p className="flex items-center gap-2" data-id="element-57">
            <span className="h-2 w-2 rounded-full bg-emerald-500" data-id="element-58"></span>
            Accepting new clients (Virtual & In-Person)
          </p>
        </div>
      </div>
    </footer>;
}